<template>
  <div class="btn-work-time-fixed-wrap" v-if="status !== null">

    <vs-button
      :class="'work-time-button'"
      type="filled"
      @click="changeWorkTimeStatus()"
    >
      <div v-if="this.status === 1"><span class="dark-mode-label">WORK TIME </span><span class="highlight">ON</span></div>
      <div v-else><span class="dark-mode-label">WORK TIME </span>OFF</div>
    </vs-button>

  </div>
</template>

<script>
import WorkTime from '@/models/WorkTime'
export default {
  name: 'Global.WorkTimeSwitchButton',
  data () {
    return {
      status: null,
      role: this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.role : ''
    }
  },
  methods: {
    changeWorkTimeStatus () {

      if (this.status !== null) {

        if (this.status === 1) {
          WorkTime.off()
          this.status = 2
        } else {
          WorkTime.on()
          this.status = 1
        }

      }

    },
    async workTimeStatus () {
      const response = await WorkTime.check()
      if (response.data.exist === 1) {
        this.status = 2
      } else {
        this.status = 1
      }
    }
  },
  mounted () {
    if (this.$store.getters.userInfo['companyPermissions'].indexOf('company_can_use_worktime_switch') > 0 && this.role === 'manager') {
      this.workTimeStatus()
    }
  }
}
</script>


<style lang="scss">
.btn-work-time-fixed-wrap {
  position: fixed;
  left: 115px;
  bottom: 5px;
  z-index: 99999;
}
.work-time-button {
  box-shadow: none !important;
  background-color: #414141 !important;
  border-radius: 20px;
  font-weight: bold;
}

.work-time-button .highlight {
  color: #ec813e;
}

@media only screen and (max-width: 960px) {
  .dark-mode-label {
    display: none;
  }
}
</style>
